import {captureError, commaSeparate, toTitleCase} from "../modules/helpers.js";
import {globals, globalUser} from "../modules/globals.js";
import {playSoundEffect} from "./sounds.js";
import {traitsData} from "../data/traits.js";
import {db, loadDb} from "../models/models.js";

const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October",
    "November", "December"];
const requestTimeout = 30000;

function getPointsHtml(points, unlimitedCreativePoints) {
    if (unlimitedCreativePoints) {
        return 'Max'
    } else {
        if (points >= 1000000) {
            let pointsText = (Math.round(((points / 1000000) + Number.EPSILON) * 10) / 10).toLocaleString('en') + 'M';
            return '<span class="help-text" title="' + points.toLocaleString('en') + '">' + pointsText + '</span>';
        } else if (points >= 10000) {
            let pointsText = (Math.round(((points / 1000) + Number.EPSILON) * 10) / 10).toLocaleString('en') + 'K';
            return '<span class="help-text" title="' + points.toLocaleString('en') + '">' + pointsText + '</span>';
        }
        return points.toLocaleString('en');
    }
}

function getFansHtml(fans) {
    if (fans >= 1000000) {
        let fansText = (Math.round(((fans / 1000000) + Number.EPSILON) * 100) / 100).toLocaleString('en') + 'M';
        return '<span class="help-text" title="' + fans.toLocaleString('en') + '">' + fansText + '</span>';
    } else if (fans >= 10000) {
        let fansText = (Math.round(((fans / 1000) + Number.EPSILON) * 10) / 10).toLocaleString('en') + 'K';
        return '<span class="help-text" title="' + fans.toLocaleString('en') + '">' + fansText + '</span>';
    }
    return fans.toLocaleString('en');
}

function hideContent(element) {
    $(".game-content-left-column").children('div').each(function () {
        if ($(this)[0] !== element[0]) {
            $(this).hide();
        }
        element.show();
    });
    hideEventCardContent($('#event-card'));
}

function hideEventCardContent(element) {
    $(".game-content-right-column").children('div').each(function () {
        if ($(this)[0] !== element[0]) {
            $(this).hide();
        }
        element.show();
    });
}

function hideMainMenuContent(element) {
    $(".main-page-container").children('div').each(function () {
        if ($(this)[0] !== element[0]) {
            $(this).hide();
        }
        element.show();
    });
}

function getChampionshipsDisplayName(championships, holder, excludeSuffix, addPlural) {
    let formattedNames = Array.from(championships,
        function (c) {
            if (championships.length > 1 && championships.indexOf(c) !== championships.length - 1) {
                // Get the name of n - 1 championships without the suffix if there are multiple championships
                return c.name
            }
            return getChampionshipDisplayName(c, holder, excludeSuffix, addPlural)
        });
    return commaSeparate(formattedNames, '&');
}

function getChampionshipDisplayName(championship, holder = false, excludeSuffix = false, addPlural = true) {
    let suffix = '';
    if (!excludeSuffix) {
        suffix = (holder) ? ' Champion' : ' Championship';
        if (championship['matchContract'] || championship['championshipContract']) {
            suffix = (holder) ? ' Holder' : ' Contract'
        }
        if ((championship['tagTeam'] || championship['trio']) && addPlural) {
            suffix += 's'
        }
        if (championship['event']) {
            suffix += ' (' + championship['event'] + ')'
        }
    }
    return championship['name'] + suffix;
}

function formatCompanyName(name) {
    let splitNames = name.split(' ');
    if (splitNames.length > 1) {
        let initials = Array.from(splitNames, function (x) {
            return x[0];
        });
        return initials.join('').toUpperCase();
    }
    else {
        return name.slice(0, 16) + '.'
    }
}

function formatCompanyNameBackend(name) {  // Previously format_company_name
    let splitNames = name.split(' ');
    if (splitNames.length > 2) {
        let initials = Array.from(splitNames, function (x) {
            return x[0];
        });
        return initials.join('');
    }
    else {
        return name
    }
}

function escapeHTML(str) {
    let p = document.createElement("p");
    p.appendChild(document.createTextNode(str));
    return p.innerHTML;
}

function getOvernessLevelText(overness) {
    let text;
    if (overness >= 80) {
        text = 'Over'
    }
    else if (overness >= 60) {
        text = 'Popular';
    }
    else if (overness >= 40) {
        text = 'Average';
    }
    else if (overness >= 20) {
        text = 'Not Popular';
    }
    else if (overness >= 0) {
        text = 'Stale';
    }
    return text;
}

function getRosterMemberMoraleClass(morale) {
    let moraleClass = '';
    if (morale < 20) {
        moraleClass = 'puke-green';
    }
    else if (morale < 40) {
        moraleClass = 'morale-dissatisfied-color';
    }
    else if (morale < 60) {
        moraleClass = 'yellow-green';
    }
    else {
        moraleClass = 'light-green';
    }
    return moraleClass;
}


function getRosterMemberMoraleText(morale) {
    let moraleText = '';
    if (morale >= 60) {
        moraleText = 'Happy';
    }
    else if (morale >= 40) {
        moraleText = 'Content';
    }
    else if (morale >= 20) {
        moraleText = 'Dissatisfied';
    }
    else {
        moraleText = 'Unhappy';
    }
    return moraleText;
}

function getRosterMemberFatigueClass(fatigue) {
    let fatigueClass = '';
    if (fatigue >= 70) {
        fatigueClass = 'dark-red';
    }
    else if (fatigue >= 40) {
        fatigueClass = 'dark-yellow';
    }
    return fatigueClass;
}

function getRosterMemberAlignmentHtml(data) {
    let alignment = data['alignment'];

    let alignmentClass;
    switch (data['alignment']) {
        case 'heel':
            alignmentClass = 'alignment-heel';
            break;
        case 'face':
            alignmentClass = 'alignment-face';
            break;
        default:
            alignmentClass = 'alignment-neutral';
            alignment = 'Neutral';
    }

    let alignmentMonthsHtml = '';
    if (data['alignmentMonths'] !== undefined) {
        let monthsText = 'months';
        if (data['alignmentMonths'] === 1) {
            monthsText = 'month'
        }
        let alignmentMonths = Math.round(data['alignmentMonths'] * 10) / 10;
        alignmentMonthsHtml = '<div class="light-grey">' + alignmentMonths + ' ' + monthsText + '</div>';
    }

    return '<span class="' + alignmentClass + '">' + toTitleCase(alignment) + '</span>' +
            alignmentMonthsHtml;
}

function getSuperstarTraitHelpHtml(trait) {
    let html;
    let helpText = getSuperstarTraitHelpText(trait);
    html = '<span class="help-text" title="' + helpText + '">' + trait + '</span>';
    return html;
}

function getSuperstarTraitHelpText(trait) {

    function getTraitChangeHtml(change) {
        return (change >= 0) ? ('+' + change) : '-' + (change * -1);
    }

    function getTraitChangeWord(change) {
        return (change >= 1.0) ? ('Multiplies') : ('Reduces');
    }

    if (!traitsData) {
        return ''
    }

    let helpTexts = [];
    let traitData = traitsData[trait];
    if (traitData) {
        if (traitData['gimmick_match_multiplier']) {
            let changeWord = getTraitChangeWord(traitData['gimmick_match_multiplier']);
            let changeVerb = (changeWord === 'Multiplies') ? 'by' : 'to';
            helpTexts.push('{0} gimmick match rating boost {1} {2}x'.format(changeWord, changeVerb, traitData['gimmick_match_multiplier']))
        }
        if (traitData['holy_shit_moment_chance_multiplier']) {
            let changeWord = getTraitChangeWord(traitData['holy_shit_moment_chance_multiplier']);
            let changeVerb = (changeWord === 'Multiplies') ? 'by' : 'to';
            helpTexts.push('{0} holy shit moment chance in gimmick matches {1} {2}x'.format(changeWord, changeVerb, traitData['holy_shit_moment_chance_multiplier']))
        }
        if (traitData['holy_shit_moment_pure_chance_multiplier']) {
            let changeWord = getTraitChangeWord(traitData['holy_shit_moment_pure_chance_multiplier']);
            let changeVerb = (changeWord === 'Multiplies') ? 'by' : 'to';
            helpTexts.push('{0} holy shit moment chance in non-gimmick matches in \'pure\' companies {1} {2}x'.format(changeWord, changeVerb, traitData['holy_shit_moment_pure_chance_multiplier']))
        }
        if (traitData['injury_chance_multiplier']) {
            let changeWord = getTraitChangeWord(traitData['injury_chance_multiplier']);
            let changeVerb = (changeWord === 'Multiplies') ? 'by' : 'to';
            helpTexts.push('{0} chance to get injured {1} {2}x'.format(changeWord, changeVerb, traitData['injury_chance_multiplier']))
        }
        if (traitData['cause_injury_chance_multiplier']) {
            let changeWord = getTraitChangeWord(traitData['cause_injury_chance_multiplier']);
            let changeVerb = (changeWord === 'Multiplies') ? 'by' : 'to';
            helpTexts.push('{0} chance to injure an opponent {1} {2}x'.format(changeWord, changeVerb, traitData['cause_injury_chance_multiplier']))
        }
        if (traitData['add_blood_to_opponent_chance_boost']) {
            let change = getTraitChangeHtml(traitData['add_blood_to_opponent_chance_boost']);
            helpTexts.push('Changes chance to make opponent bleed by {0}%'.format(change))
        }
        if (traitData['positive_match_rating_boost_multiplier']) {
            let changeWord = getTraitChangeWord(traitData['positive_match_rating_boost_multiplier']);
            let changeVerb = (changeWord === 'Multiplies') ? 'by' : 'to';
            helpTexts.push('{0} positive match rating effect chance {1} {2}x'.format(changeWord, changeVerb, traitData['positive_match_rating_boost_multiplier']))
        }
        if (traitData['negative_match_rating_boost_multiplier']) {
            let changeWord = getTraitChangeWord(traitData['negative_match_rating_boost_multiplier']);
            let changeVerb = (changeWord === 'Multiplies') ? 'by' : 'to';
            helpTexts.push('{0} negative match rating effect chance {1} {2}x'.format(changeWord, changeVerb, traitData['negative_match_rating_boost_multiplier']))
        }
        if (traitData['monthly_event_match_rating_boost']) {
            let change = getTraitChangeHtml(traitData['monthly_event_match_rating_boost']);
            helpTexts.push('Changes match ratings by {0} on monthly events'.format(change))
        }
        if (traitData['weekly_show_match_rating_boost']) {
            let change = getTraitChangeHtml(traitData['weekly_show_match_rating_boost']);
            helpTexts.push('Changes match ratings by {0} on weekly shows'.format(change))
        }
        if (traitData['hot_match_chance_boost']) {
            let change = getTraitChangeHtml(traitData['hot_match_chance_boost']);
            helpTexts.push('Changes hot match chance by {0}%'.format(change))
        }
        if (traitData['no_morale_change_except_rank']) {
            helpTexts.push('Mostly happy to lose to anyone except {0}s'.format(traitData['no_morale_change_except_rank']))
        }
        if (traitData['no_morale_change_rank']) {
            helpTexts.push('Mostly happy to lose to {0}s'.format(traitData['no_morale_change_rank']))
        }
        if (traitData['loss_affects_morale_chance']) {
            helpTexts.push('{0}% chance for losses to lower morale'.format(traitData['loss_affects_morale_chance']))
        }
        if (traitData['win_affects_morale_chance']) {
            helpTexts.push('{0}% chance for wins to raise morale'.format(traitData['win_affects_morale_chance']))
        }
        if (traitData['leaving_chance_multiplier']) {
            let changeWord = getTraitChangeWord(traitData['leaving_chance_multiplier']);
            let changeVerb = (changeWord === 'Multiplies') ? 'by' : 'to';
            helpTexts.push('{0} chance to leave if unhappy {1} {2}x'.format(changeWord, changeVerb, traitData['leaving_chance_multiplier']))
        }
        if (traitData['training_xp_multiplier']) {
            let changeWord = getTraitChangeWord(traitData['training_xp_multiplier']);
            let changeVerb = (changeWord === 'Multiplies') ? 'by' : 'to';
            helpTexts.push('{0} training XP gain {1} {2}x'.format(changeWord, changeVerb, traitData['training_xp_multiplier']))
        }
        if (traitData['skill_xp_multiplier']) {
            let changeWord = getTraitChangeWord(traitData['skill_xp_multiplier']);
            let changeVerb = (changeWord === 'Multiplies') ? 'by' : 'to';
            helpTexts.push('{0} skill XP gain in matches and segments {1} {2}x'.format(changeWord, changeVerb, traitData['skill_xp_multiplier']))
        }
        if (traitData['retirement_chance_multiplier']) {
            let changeWord = getTraitChangeWord(traitData['retirement_chance_multiplier']);
            let changeVerb = (changeWord === 'Multiplies') ? 'by' : 'to';
            helpTexts.push('{0} retirement chance {1} {2}x'.format(changeWord, changeVerb, traitData['retirement_chance_multiplier']))
        }
        if (traitData['retirement_age_change']) {
            let change = getTraitChangeHtml(traitData['retirement_age_change']);
            helpTexts.push('Changes retirement age by {0}'.format(change))
        }
        if (traitData['turn_part_timer_age_change']) {
            let change = getTraitChangeHtml(traitData['turn_part_timer_age_change']);
            helpTexts.push('Changes age of turning part-timer by {0}'.format(change))
        }
        if (traitData['overness_increase_multiplier']) {
            let changeWord = getTraitChangeWord(traitData['overness_increase_multiplier']);
            let changeVerb = (changeWord === 'Multiplies') ? 'by' : 'to';
            helpTexts.push('{0} overness increases {1} {2}x'.format(changeWord, changeVerb, traitData['overness_increase_multiplier']))
        }
        if (traitData['overness_decrease_multiplier']) {
            let changeWord = getTraitChangeWord(traitData['overness_decrease_multiplier']);
            let changeVerb = (changeWord === 'Multiplies') ? 'by' : 'to';
            helpTexts.push('{0} overness decreases {1} {2}x'.format(changeWord, changeVerb, traitData['overness_decrease_multiplier']))
        }
        if (traitData['silly_segment_rating_boost']) {
            let change = getTraitChangeHtml(traitData['silly_segment_rating_boost']);
            helpTexts.push('Changes silly segment ratings by {0}'.format(change))
        }
        if (traitData['hot_segment_chance_boost']) {
            let change = getTraitChangeHtml(traitData['hot_segment_chance_boost']);
            helpTexts.push('Changes hot segment chance by {0}%'.format(change))
        }
        if (traitData['face_alignment_hype_boost']) {
            let change = getTraitChangeHtml(traitData['face_alignment_hype_boost']);
            helpTexts.push('Changes face alignment hype boost for matches and feuds by {0}'.format(change))
        }
        if (traitData['heel_alignment_hype_boost']) {
            let change = getTraitChangeHtml(traitData['heel_alignment_hype_boost']);
            helpTexts.push('Changes heel alignment hype boost for matches and feuds by {0}'.format(change))
        }
        if (traitData['face_alignment_penalty']) {
            let change = getTraitChangeHtml(traitData['face_alignment_penalty']);
            helpTexts.push('Adds hype penalty of {0} when aligned as a face'.format(change))
        }
        if (traitData['heel_alignment_penalty']) {
            let change = getTraitChangeHtml(traitData['heel_alignment_penalty']);
            helpTexts.push('Adds hype penalty of {0} when aligned as a heel'.format(change))
        }
        if (traitData['fantasy_gimmick_character_boost']) {
            let change = getTraitChangeHtml(traitData['fantasy_gimmick_character_boost']);
            helpTexts.push('Changes gimmick effectiveness for fantasy characters by {0}%'.format(change))
        }
        if (traitData['non_fantasy_gimmick_character_boost']) {
            let change = getTraitChangeHtml(traitData['non_fantasy_gimmick_character_boost']);
            helpTexts.push('Changes gimmick effectiveness for non-fantasy characters by {0}%'.format(change))
        }
        if (traitData['bad_combination_gimmick_boost']) {
            let change = getTraitChangeHtml(traitData['bad_combination_gimmick_boost']);
            helpTexts.push('Changes gimmick effectiveness for bad combination gimmicks by {0}%'.format(change))
        }
        if (traitData['gimmick_boost']) {
            let change = getTraitChangeHtml(traitData['gimmick_boost']);
            helpTexts.push('Changes gimmick effectiveness for all gimmicks by {0}%'.format(change))
        }
        if (traitData['gimmick_interview_superstar_chance']) {
            helpTexts.push('Adds {0}% chance to be in the Gimmick Interview random event'.format(traitData['gimmick_interview_superstar_chance']))
        }
        if (traitData['hot_feud_chance_boost']) {
            let change = getTraitChangeHtml(traitData['hot_feud_chance_boost']);
            helpTexts.push('Changes hot feud chance by {0}%'.format(change))
        }
        if (traitData['feud_staleness_limit_boost']) {
            let change = getTraitChangeHtml(traitData['feud_staleness_limit_boost']);
            helpTexts.push('Changes feud staleness limit by {0}'.format(change))
        }
        if (traitData['feud_boosted_feud_chance']) {
            helpTexts.push('Adds {0}% chance to be in the Feud Boosted random event'.format(traitData['feud_boosted_feud_chance']))
        }
        if (traitData['feud_ignored_feud_chance']) {
            helpTexts.push('Adds {0}% chance to be in the Feud Ignored random event'.format(traitData['feud_ignored_feud_chance']))
        }
        if (traitData['feud_hype_change_boost']) {
            let change = getTraitChangeHtml(traitData['feud_hype_change_boost']);
            helpTexts.push('Adds {0} to feud hype change in matches and segments'.format(change))
        }
        if (traitData['gimmick_effectiveness_increase_multiplier']) {
            let changeWord = getTraitChangeWord(traitData['gimmick_effectiveness_increase_multiplier']);
            let changeVerb = (changeWord === 'Multiplies') ? 'by' : 'to';
            helpTexts.push('{0} gimmick effectiveness change {1} {2}x'.format(changeWord, changeVerb, traitData['gimmick_effectiveness_increase_multiplier']))
        }
        if (traitData['morale_boost_helper_chance']) {
            helpTexts.push('Adds {0}% chance to be in the Morale Boost random event'.format(traitData['morale_boost_helper_chance']))
        }
        if (traitData['wrestler_court_judge_chance']) {
            helpTexts.push('Adds {0}% chance to be a judge in the Wrestlers Court random event'.format(traitData['wrestler_court_judge_chance']))
        }
        if (traitData['wrestler_court_defendant_chance']) {
            helpTexts.push('Adds {0}% chance to be a defendant in the Wrestlers Court random event'.format(traitData['wrestler_court_defendant_chance']))
        }
        if (traitData['backstage_fight_starter_chance']) {
            helpTexts.push('Adds {0}% chance to be in the Backstage Fight random event'.format(traitData['backstage_fight_starter_chance']))
        }
        if (traitData['drug_abuse_superstar_chance']) {
            helpTexts.push('Adds {0}% chance to be in the Drug Abuse random event'.format(traitData['drug_abuse_superstar_chance']))
        }
        if (traitData['tag_match_workrate_boost']) {
            let change = getTraitChangeHtml(traitData['tag_match_workrate_boost']);
            helpTexts.push('Changes workrate by {0} in tag matches'.format(change))
        }
        if (traitData['lose_trait_chance_multiplier']) {
            let changeWord = getTraitChangeWord(traitData['lose_trait_chance_multiplier']);
            let changeVerb = (changeWord === 'Multiplies') ? 'by' : 'to';
            helpTexts.push('{0} chance to lose traits with age {1} {2}x'.format(changeWord, changeVerb, traitData['lose_trait_chance_multiplier']))
        }
        if (traitData['add_blood_chance_boost']) {
            let change = getTraitChangeHtml(traitData['add_blood_chance_boost']);
            helpTexts.push('Changes chance to bleed by {0}%'.format(change))
        }
        if (traitData['months_to_unlearn_traits_boost']) {
            let change = getTraitChangeHtml(traitData['months_to_unlearn_traits_boost']);
            helpTexts.push('Changes number of months needed to unlearn traits by {0}'.format(change))
        }
        if (traitData['weekly_show_match_fatigue_change']) {
            let change = getTraitChangeHtml(traitData['weekly_show_match_fatigue_change']);
            helpTexts.push('Changes match fatigue by {0} on weekly shows'.format(change))
        }
        if (traitData['monthly_event_match_fatigue_change']) {
            let change = getTraitChangeHtml(traitData['monthly_event_match_fatigue_change']);
            helpTexts.push('Changes match fatigue by {0} on monthly events'.format(change))
        }
        if (traitData['gimmick_match_fatigue_multiplier']) {
            let changeWord = getTraitChangeWord(traitData['gimmick_match_fatigue_multiplier']);
            let changeVerb = (changeWord === 'Multiplies') ? 'by' : 'to';
            helpTexts.push('{0} gimmick match fatigue change {1} {2}x'.format(changeWord, changeVerb, traitData['gimmick_match_fatigue_multiplier']))
        }
        if (traitData['remove_fatigue_age_penalty']) {
            helpTexts.push('Removes fatigue penalty normally added past the age of 40')
        }
    }

    let helpText = helpTexts.join('. ');
    helpText += '.';

    return helpText;
}

function getTraitHelpHtml(traitName, traitData) {
    let conflictingTraitsHtml = '';
    if (traitData['conflicting_traits'].length > 0) {
        conflictingTraitsHtml = '<div class="margin-top-7 medium-dark-grey">Conflicts with ' + commaSeparate(traitData['conflicting_traits']) + '.</div>'
    }

    let loseWithAgeHtml = '';
    if (traitData['disable_lose_with_age']) {
        loseWithAgeHtml = '<div class="medium-dark-grey margin-top-7">Cannot lose with age.</div>';
    }

    let acquirableHtml = '';
    if (traitData['acquirable']) {
        // Get requirements from array
        let requirementsToAcquireHtml = '';
        if (traitData['requirements_to_acquire'].length > 0) {
            let requirementsToAcquire = Array.from(traitData['requirements_to_acquire'], function (x) {
                return parseObjectiveName(x.replace(/_/g, ' '), 'faded-blue', 3);
            });
            requirementsToAcquireHtml = '<span class="margin-left-5">(requires {0})</span>'.format(commaSeparate(requirementsToAcquire));
        }

        acquirableHtml = '<div class="faded-blue margin-top-7">' +
            'Chance to acquire via {0}{1}.'.format(parseObjectiveName(traitData['action_to_acquire'], 'faded-blue'), requirementsToAcquireHtml) +
            '</div>';
    }

    // Add can unlearn data
    let canUnlearnHtml = '';
    if (traitData['can_unlearn']) {
        canUnlearnHtml = '<div class="faded-blue margin-top-7">' +
            'Can be unlearned by a {0}.'.format(toTitleCase(traitData['staff_role_to_unlearn'].replace(/_/g, ' '))) +
            '</div>';
    }

    let html =
        '<div class="margin-bottom-10">' +
            '<div class="superstar-trait-color font-15px">' + traitName + '</div>' +
        '</div>' +

        '<div class="margin-bottom-7">' +
            traitData['description'] +
        '</div>' +

        '<div class="medium-dark-grey">' +
            getSuperstarTraitHelpText(traitName) +
        '</div>' +
        conflictingTraitsHtml +
        loseWithAgeHtml +
        acquirableHtml +
        canUnlearnHtml;

    return '<div class="trait-help-item-container">' + html + '</div>';
}

function getTalentRequestTypesHelpHtml(data) {
    let talentRequestTypesHelpHtml = '';
    data.forEach(function (talentRequestTypeData) {
        let importantHtml = '';
        if (talentRequestTypeData['importance'] === 'major') {
            importantHtml = '<div class="faded-blue margin-top-5 help-text" title="Important requests have a higher morale change.">' +
                'Important' +
                '</div>';
        }
        talentRequestTypesHelpHtml += '<div class="morale-help-item-container dark-grey">' +
            '<div>' +
            '<div class="superstar-trait-color font-15px">' + talentRequestTypeData['name'] + '</div>' +
            '</div>' +
            '<div class="margin-top-8">' +
            talentRequestTypeData['description'] +
            '</div>' +
            importantHtml +
            '</div>'
    });
    return talentRequestTypesHelpHtml;
}

function getChampionshipPrestigeIconHtml(prestige) {
    let iconClass = 'bronze';
    if (prestige === 'S') {
        iconClass = 'obsidian'
    }
    else if (prestige === 'A') {
        iconClass = 'gold-light'
    }
    else if (prestige === 'B') {
        iconClass = 'silver'
    }
    else if (prestige === 'C') {
        iconClass = 'bronze'
    }
    return '<i class="fa fa-star-o font-bold ' + iconClass + '"></i>';
}

function getStarRatingHtml(rating, colorClass, maxStars) {
    if (typeof(colorClass) === 'undefined') colorClass = '';
    if (typeof(maxStars) === 'undefined') maxStars = 5;
    let ratingValue = rating;
    let ratingFloor = Math.floor(ratingValue);
    let decimalRating = ratingValue - ratingFloor;
    let ratingText = '<i class="fa fa-star"></i>'.repeat(ratingFloor);
    if (decimalRating) {
        if (decimalRating === 0.75) {
            decimalRating = 0.70;
        }
        else if (decimalRating === 0.25) {
            decimalRating = 0.35;
        }
        ratingText += '<i class="star star-under fa fa-star">' +
            '<i class="star star-over ' + colorClass + ' fa fa-star" style="width: ' + decimalRating * 100 + '%"></i>' +
            '</i>';
        if (ratingFloor < maxStars) {
            ratingText += '<i class="fa fa-star star-under"></i>'.repeat(maxStars - ratingFloor - 1);
        }
    }
    else {
        if (ratingFloor < maxStars) {
            ratingText += '<i class="fa fa-star star-under"></i>'.repeat(maxStars - ratingFloor);
        }
    }
    return ratingText;
}

function setRating(rating) {
    let ratingText;
    if (rating !== null) {
        let ratingFloor = Math.floor(rating);
        let decimalRating = rating - ratingFloor;
        ratingText = '<i class="fa fa-star"></i>'.repeat(ratingFloor);
        if (decimalRating) {
            if (decimalRating === 0.75) {
                decimalRating = 0.70;
            }
            else if (decimalRating === 0.25) {
                decimalRating = 0.35;
            }
            ratingText += '<i class="star star-under fa fa-star">' +
                '<i class="star star-over fa fa-star" style="width: ' + decimalRating * 100 + '%"></i>' +
                '</i>';
            if (ratingFloor < 5) {
                ratingText += '<i class="fa fa-star star-under"></i>'.repeat(5 - ratingFloor - 1);
            }
        }
        else {
            if (ratingFloor < 5) {
                ratingText += '<i class="fa fa-star star-under"></i>'.repeat(5 - ratingFloor);
            }
        }
    }
    else {
        // Set rating element
        ratingText = 'No Rating';
    }
    return ratingText;
}

function parseObjectiveName(objectiveName, colorClass, maxStars) {
    if (typeof(colorClass) === 'undefined') colorClass = 'goal-color';
    return objectiveName.replace(/\S+(?=\*)/g, function (rating) {
        return getStarRatingHtml(rating, colorClass, maxStars);
    }).replace(
        /\d+\b(?!%)/g, function (match) {
            return match
        }
    ).replace('*', '');
}

function getSuperstarInjuredText(data) {
    let injuryNameText = '';
    if (data['injuryName']) {
        injuryNameText = ' from a ' + data['injuryName'];
    }
    let monthsWord = (data['injuryTime'] === '1') ? 'month' : 'months';
    let injuryWord = (data['workableInjury']) ? 'Recovers' : 'Returns';
    return '{0} in {1} {2} {3}'.format(injuryWord, data['injuryTime'], monthsWord, injuryNameText);
}

function getViewershipText(viewership) {
    let absoluteViewership = Math.abs(viewership);
    if (absoluteViewership < 1000) {
        return viewership;
    }
    else if (absoluteViewership < 1000000) {
        return '{0}K'.format(Math.round((viewership / 1000 + Number.EPSILON) * 10) / 10);
    }
    else {
        return '{0}M'.format(Math.round((viewership / 1000000 + Number.EPSILON) * 100) / 100);
    }
}

function getShortenedName(name, maxLength, reverse) {
    if (typeof(maxLength) === 'undefined') maxLength = 18;
    let splitNames = name.split(" ");
    let nameEdited = false;
    while (name.length > maxLength && splitNames.length > 1) {
        if (reverse) {
            let firstIndex = name.indexOf(" ");
            name = name.substring(firstIndex + 1);
        }
        else {
            let lastIndex = name.lastIndexOf(" ");
            name = name.substring(0, lastIndex);
        }
        splitNames = name.split(" ");
        nameEdited = true;
    }
    if (nameEdited) {
        if (!reverse) {
            name += ' .'
        }
    }
    return name;
}

function getTimesWord(times) {
    if (times === 1) {
        return 'time'
    }
    return 'times'
}

function applySentenceCase(str) {
    if (!str) {
        return str
    }
    return str.replace(/.+?[\.\?\!](\s|$)/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1);
    });
}

function replaceAll(str, find, replace) {
    if (!str) {
        return str
    }
    return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
}

function escapeRegExp(str) {
    return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
}

function runFuseElementsSearch(elements, searchTerm, keys) {
    let options = {
        keys: keys,
        shouldSort: true,
        distance: 70,
        threshold: 0.3
    };
    let fuse = new Fuse(elements, options);
    return fuse.search(searchTerm);
}

function runAnnualTournamentSelectionsSearch() {
    let parent = $('.annual-tournament-selections-container');
    let selectionsContainer = parent.find('.annual-tournament-selection-items-container');
    let selectionElements = parent.find('.annual-tournament-selection-item:not(.no-annual-tournament-selections-search-results)')
    let searchTerm = parent.find(".annual-tournament-selections-search-input").val();

    selectionElements.hide();

    // Run search
    if (searchTerm.length > 0) {
        let searchResults = runFuseElementsSearch(selectionElements, searchTerm, ['textContent']);
        // Show results if found
        if (searchResults.length > 0) {
            searchResults.forEach(function (e) {
                $(e).show()
            });
            $('.no-annual-tournament-selections-search-results').hide();
        }
        else {
            if ($('.no-annual-tournament-selections-search-results').length > 0) {
                $('.no-annual-tournament-selections-search-results').show()
            }
            else {
                selectionsContainer.append('<div class="no-annual-tournament-selections-search-results inner-box-item ' +
                    'annual-tournament-selection-item unavailable light-grey">No Results Found</div>')
            }
        }
    }
    else {
        selectionElements.show();
        $('.no-annual-tournament-selections-search-results').hide();
    }

    selectionsContainer.scrollTop(0);
    selectionsContainer[0].scrollIntoView();
}

function getChampionshipGimmickRestrictionText(data) {
    let text;
    if (data) {
        if (data['type'] === 'gimmick_match') {
            if (data['value']) {
                text = data['value'] + " Matches Only";
            }
            else {
                text = "Gimmick Matches Only"
            }
        }
        else if (data['type'] === 'weekly_show') {
            text = 'Weekly Shows Only'
        }
        else if (data['type'] === 'maximum_age') {
            text = data['value'] + ' years old or younger'
        }
        else if (data['type'] === 'minimum_age') {
            text = data['value'] + ' years old or older'
        }
    }
    return text;
}

function getChampionshipPrestigeProgressHtml(data) {
    let progress = 100;
    let xpToLevel = '';
    if (!data['maxPrestige']) {
        progress = data['progressPercentage'];
    }
    else {
        xpToLevel = 'Max Prestige'
    }

    if (progress > 100) {
        progress = 100
    }
    else if (progress <= 0) {
        progress = 1
    }

    let prestigeIcon = '<span class="margin-left-6">' +
        getChampionshipPrestigeIconHtml(data['prestige']) +
        '</span>';

    return '<div class="progress-under compact narrow help-text championship-prestige-progress display-inline-block"' +
        ' title="' + data['xp'] + ' / ' + data['nextPrestigeXp'] + ' XP">' +
            '<div class="progress compact" style="width:' +
            progress + '%">' + '</div>' +
        '</div>' + prestigeIcon +
        '<div class="display-block margin-left-1 margin-top-3">' +
            '<div class="display-inline-block font-0p925em grey">' + xpToLevel + '</div>' +
        '</div>';
}

function getCompanyHeaderHtml(companyName, playerName) {
    if (companyName.length > 18) {
        companyName = formatCompanyName(companyName)
    }
    let html = companyName;
    if (globals.game.sandboxModeEnabled) {
        html = '<span class="sandbox-mode-color help-text" title="Sandbox Mode">' + html + '</span>';
    }
    if (globals.game.story === 'passion') {
        html = '<span class="pow-color">' + html + '</span>';
    }
    if (globals.game.controlMultipleCompanies) {
        if (playerName) {
            html += '<span class="light-grey margin-left-8">{0}</span>'.format(playerName);
        }
        $('.change-company-button').show();
    }
    else {
        $('.change-company-button').hide();
    }
    return html
}

function getGimmickDescription(gimmick) {
    // Debuted
    if (gimmick['effectiveness']) {
        let gimmickEffectiveness = '(' + gimmick['effectiveness'] + '%)';
        let gimmickBoost =
            '<span class="display-block">' +
            getGimmickEffectivenessBonusHtml(gimmick['effectiveness']) +
            '<span class="light-grey"> Overness Effect</span>' +
            '</span>';
        let effectivenessText = getGimmickEffectivenessHtml(gimmick['effectiveness']);
        return gimmick['name'] +
            '<span class="margin-left-8">' + effectivenessText + '</span>' +
            '<span class="margin-left-8 light-grey">' + gimmickEffectiveness + '</span>' + gimmickBoost;
    }
    // Not debuted
    else {
        let combinationHtml = getGimmickCombinationHtml(gimmick['combinationResult']);
        return gimmick['name'] +
            '<span class="margin-left-8 light-grey">Not Debuted</span>' +
            '<span class="margin-left-8">' + combinationHtml + '</span>'
    }
}

function getGimmickEffectivenessHtml(effectiveness) {
    let text;
    if (effectiveness >= 80) {
        text = '<span class="light-green">Mark Out!</span>'
    }
    else if (effectiveness >= 60) {
        text = '<span class="green">Good</span>';
    }
    else if (effectiveness >= 40) {
        text = '<span class="dark-yellow">Average</span>';
    }
    else if (effectiveness >= 20) {
        text = '<span class="dark-red">Not Good</span>';
    }
    else if (effectiveness >= 0) {
        text = '<span class="red">Bad</span>';
    }
    return text;
}

function getGimmickEffectivenessText(effectiveness) {
    let text;
    if (effectiveness >= 80) {
        text = 'Mark Out'
    }
    else if (effectiveness >= 60) {
        text = 'Good';
    }
    else if (effectiveness >= 40) {
        text = 'Average';
    }
    else if (effectiveness >= 20) {
        text = 'Not Good';
    }
    else if (effectiveness >= 0) {
        text = 'Bad';
    }
    return text;
}

function getGimmickCombinationHtml(combination) {
    let text;
    switch (combination) {
        case 'easy':
            text = '<span class="green">Easy</span>';
            break;
        case 'hard':
            text = '<span class="red">Hard</span>';
            break;
        case 'okay':
            text = '<span class="dark-yellow">Okay</span>';
            break;
    }
    return text;
}

function getGimmickEffectivenessBonusHtml(effectiveness) {
    let text;
    if (effectiveness >= 80) {
        text = '<span class="green">+ 15</span>'
    }
    else if (effectiveness >= 60) {
        text = '<span class="green">+ 5</span>';
    }
    else if (effectiveness >= 40) {
        text = '<span class="dark-yellow">+ 0</span>';
    }
    else if (effectiveness >= 20) {
        text = '<span class="red">- 5</span>';
    }
    else if (effectiveness >= 0) {
        text = '<span class="red">- 15</span>';
    }
    return text;
}

function populateBrandNameSelect(brandNames, select) {
    let brandNamesOptions = '<option value="">None</option>';
    brandNames.forEach(function (brandName) {
        brandNamesOptions += '<option value="' + brandName.replace(/"/g, "&quot;") + '">' + brandName + '</option>'
    });
    select.html(brandNamesOptions);
}

async function makeGameRequest(getFunction, getFunctionArgs, showFunction, showFunctionArgs = {}, hide = true,
                               subRequest = false, setRequestRunning = true, hideAlerts = true) {  // Don't show loading or play sounds for sub request (since already done before)

    try {
        // Don't run if request running
        if (globals.requestRunning) {
            return;
        }

        // Get function
        if (!subRequest) {
            notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
        }
        if (setRequestRunning) {
            globals.requestRunning = true
        }
        let data = await getFunction(getFunctionArgs);
        globals.requestRunning = false;

        if (hideAlerts) {
            notie.hideAlerts();
        }

        // Play sound effect
        if (!data['error']) {
            if (!subRequest) {
                playSoundEffect('success');
            }
            // Hide ui
            if (hide) {
                hideContent($());
            }
        }
        else {
            if (!subRequest) {
                playSoundEffect('error')
            }
        }

        // Show function with data
        showFunctionArgs.data = data;
        await showFunction(showFunctionArgs);
    } catch (error) {
        notie.alert({type: 3, text: "An error occurred."});
        playSoundEffect('error');
        captureError(error);
        globals.requestRunning = false;
        await loadDb(db.filename);
    }
}

function makeGetRequest(url, data, callback, continueRequest = false, notieText = null, showNotie = true) {
    if (!notieText) {
        notieText = 'Loading'
    }
    if (showNotie) {
        notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>' + notieText, stay: true});
        globals.requestRunning = true;
    }

    $.ajax({
        url: globals.baseUrl + url,
        dataType: 'json',
        data: data,
        success: async (data) => {
            if (!continueRequest) {
                globals.requestRunning = false;
                notie.hideAlerts();
            }

            await callback(data);
        },
        timeout: requestTimeout,
        error: function (jqXHR, status, errorThrown) {
            globals.requestRunning = false;
            notie.hideAlerts();

            if (!window.navigator.onLine) {
                notie.alert({type: 3, text: 'It seems like you\'re offline. Please check your internet connection and try again.'});
            }
            else {
                if (status === 'timeout') {
                    notie.alert({type: 3, text: 'The request timed out. Please try again.'});
                } else {
                    notie.alert({type: 3, text: 'An error occurred while making this request. Please try again.'});
                }
                captureError(new Error('error for get request ' + url + ' ' + errorThrown));
            }
        }
    });
}

function predicateBy(prop) {
    return function (a, b) {
        if (a[prop] > b[prop]) {
            return 1;
        } else if (a[prop] < b[prop]) {
            return -1;
        }
        return 0;
    }
}

function objectEquals(x, y) {
    'use strict';

    if (x === null || x === undefined || y === null || y === undefined) {
        return x === y;
    }
    // after this just checking type of one would be enough
    if (x.constructor !== y.constructor) {
        return false;
    }
    // if they are functions, they should exactly refer to same one (because of closures)
    if (x instanceof Function) {
        return x === y;
    }
    // if they are regexps, they should exactly refer to same one (it is hard to better equality check on current ES)
    if (x instanceof RegExp) {
        return x === y;
    }
    if (x === y || x.valueOf() === y.valueOf()) {
        return true;
    }
    if (Array.isArray(x) && x.length !== y.length) {
        return false;
    }

    // if they are dates, they must had equal valueOf
    if (x instanceof Date) {
        return false;
    }

    // if they are strictly equal, they both need to be object at least
    if (!(x instanceof Object)) {
        return false;
    }
    if (!(y instanceof Object)) {
        return false;
    }

    // recursive object equality check
    let p = Object.keys(x);
    return Object.keys(y).every(function (i) {
            return p.indexOf(i) !== -1;
        }) &&
        p.every(function (i) {
            return objectEquals(x[i], y[i]);
        });
}

function getFeudPotentialHtml(feud) {
    let participants = feud['participants'].join(' and ');
    let feudPotential = 'Feud Potential';
    if (feud['started']) {
        feudPotential = 'Feud started'
    }
    return '<span class="faded-red-light">' + feud['name'] + '</span>' + ' ' + feudPotential + ' between ' + participants;
}

window.mobilecheck = function () {
    let check = false;
    (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};

function getChampionshipGimmickRestrictionInfoHtml(data) {
    let text;
    if (data['gimmickRestriction']['type'] === 'gimmick_match') {
        if (data['gimmickRestriction']['value']) {
            text = data['name'] + " can only be contested in " +
                data['gimmickRestriction']['value'] + " Matches";
        }
        else {
            text = data['name'] + " can only be contested in Gimmick Matches";
        }
    }
    else if (data['gimmickRestriction']['type'] === 'weekly_show') {
        text = data['name'] + " can only be contested on Weekly Shows";
    }
    else if (data['gimmickRestriction']['type'] === 'maximum_age') {
        text = data['name'] + " can only be contested by Superstars " + data['gimmickRestriction']['value'] +
            " years old or younger";
    }
    else if (data['gimmickRestriction']['type'] === 'minimum_age') {
        text = data['name'] + " can only be contested by Superstars " + data['gimmickRestriction']['value'] +
            " years old or older";
    }
    return '<span class="display-block">' + text + '</span>';
}

function getGimmickMatchUnlockedBy(name) {
    let unlockedByName;
    switch (name) {
        case 'TLC':
            unlockedByName = 'Ladder';
            break;
        case 'Tables':
            unlockedByName = 'Ladder';
            break;
        case 'Brawl':
            unlockedByName = 'Ironman';
            break;
        case 'Casket':
            unlockedByName = 'Ironman';
            break;
        case 'Steel Cell':
            unlockedByName = 'Steel Cage';
            break;
        case 'Hell In A Cell':
            unlockedByName = 'Steel Cage';
            break;
        case 'Loser Leaves':
            unlockedByName = 'Submission';
            break;
        case 'Unsanctioned':
            unlockedByName = 'Street Fight';
            break;
        case 'LMS':
            unlockedByName = 'Street Fight';
            break;
        case 'Ambulance':
            unlockedByName = 'Street Fight';
            break;
        case 'Flag':
            unlockedByName = 'Pole';
            break;
        case 'Graphene Cell':
            unlockedByName = 'Graphene Cage';
            break;
        case 'Spaceflight':
            unlockedByName = 'Glacier Escape';
            break;
        case 'Chemical Warfare':
            unlockedByName = 'Canyon Fight';
            break;
    }
    return unlockedByName;
}

function updateGamePointsAndFans(points, fans) {
    let gamePointsHtml = getPointsHtml(points, globals.game.unlimitedCreativePoints);
    $(".points-number").html(gamePointsHtml).hide().fadeIn();
    let gameFansHtml = getFansHtml(fans);
    $(".fans-number").html(gameFansHtml).hide().fadeIn();
}

function getGimmickDebutHtml(gimmick, show) {
    let effectivenessText;
    if (!show) {
        effectivenessText = '<span class="gimmick-effectiveness-text margin-left-5"></span>'
    } else {
        effectivenessText = '<span class="gimmick-effectiveness-text margin-left-3">' +
            getGimmickEffectivenessHtml(gimmick['effectiveness']) + '</span>';
    }

    let gimmickName = '<span class="character-label">' + gimmick['name'] + '</span>';

    let gimmickEffectiveness;
    if (!show) {
        let productionBoost = '';
        if (gimmick['productionBoost']) {
            productionBoost = 'data-production-boost="' + gimmick['productionBoost'] + '" '
        }
        gimmickEffectiveness = '<span class="grey margin-left-5"><span class="gimmick-effectiveness" ' +
            productionBoost +
            'data-value="' + gimmick['effectiveness'] + '" data-overness-change="' + gimmick['overnessEffectChange'] + '">' +
            '</span><span class="margin-left-2">%</span></span>';
    } else {
        gimmickEffectiveness = '<span class="grey margin-left-3">' + gimmick['effectiveness'] +
            '<span class="margin-left-2">%</span></span>';
    }

    return '{0} debuted a new {1} Gimmick {2} {3}'.format(gimmick['superstar'], gimmickName,
        gimmickEffectiveness, effectivenessText);
}

function addTournamentParticipantsEditing(elementClassName) {
    $('.tournament-participant').draggable({
        revert: true, containment: elementClassName,
        stack: '.tournament-participant', revertDuration: 30,
        opacity: 0.6, scroll: true
    });
    $(".tournament-participant").droppable({
        accept: '.tournament-participant',
        activeClass: "droppable-hover",
        hoverClass: "droppable-active",
        drop: function (event, ui) {
            let draggable = ui.draggable, droppable = $(this);
            draggable.swap(droppable);

            setTimeout(function () {
                droppable.addClass("color-change-grey");
                draggable.addClass("color-change-grey");
            }, 50);
            setTimeout(function () {
                droppable.removeClass("color-change-grey");
                draggable.removeClass("color-change-grey");
            }, 800);
        }
    });
}

jQuery.fn.swap = function (b) {
    // method from: http://blog.pengoworks.com/index.cfm/2008/9/24/A-quick-and-dirty-swap-method-for-jQuery
    b = jQuery(b)[0];
    let a = this[0];
    let t = a.parentNode.insertBefore(document.createTextNode(''), a);
    b.parentNode.insertBefore(a, b);
    t.parentNode.insertBefore(b, t);
    t.parentNode.removeChild(t);
    return this;
};


function getTournamentGroupsHtml(groups, participants, edit) {
    if (typeof(edit) === 'undefined') edit = false;

    let html = '';
    let bracketClass = '';
    if (participants >= 16) {
        bracketClass = 'compact'
    }

    groups.forEach(function (group, i) {

        html += '<div class="tournament-group-container">';

        // Add group name
        let groupName = getTournamentGroupName(i + 1);
        html +=
            '<span class="display-block margin-bottom-10 text-center medium-dark-grey">' +
            '<span class="tournament-group-name">Group ' + groupName + '</span>' +
            '</span>';

        // Add group participants
        html += '<div class="tournament-bracket-match ' + bracketClass + '">';

        group.forEach(function (participant, j, arr) {
            let participantSeed = participant[1];
            let participantName = participant[0];

            let editClass = '';
            if (edit) {
                editClass = 'edit'
            }

            html +=
                '<div class="tournament-participant ' + editClass + '">' +
                '<span class="tournament-participant-seed margin-right-5 light-grey">' + participantSeed + '</span>' +
                '<span class="tournament-participant-name">' + participantName + '</span>' +
                '</div>';

            if (j !== arr.length - 1) {
                html += '<div class="tournament-participant-separator"></div>'
            }
        });

        html += '</div></div>';
    });

    return html
}

function getTournamentGroupName(n) {
    switch (n) {
        case 1:
            return 'A';
        case 2:
            return 'B';
        case 3:
            return 'C';
        case 4:
            return 'D';
        default:
            return n
    }
}

function getFeudStartedHtml(feud) {
    let participants = feud['participants'].join(' and ');
    let html = '<span class="faded-red-light">' + feud['name'] + '</span>' + ' Feud started between ' + participants;
    if (feud['shocking']) {
        html += '. Extra Hype surrounds the Feud due to the shocking turn.'
    }

    let prev = '';
    if (feud['boosts']['previousFeudBoost']) {
        prev =
            '<span class="margin-left-12 grey help-text" title="Hype added due to Participants\' latest Feud">Prev. Feud' +
            '<span class="faded-red-extra-light">' +
            '<i class="fa fa-bolt margin-right-5 margin-left-8"></i>' + feud['boosts']['previousFeudBoost'] +
            '</span>' +
            '</span>'
    }
    let turnHype = '';
    if (feud['turnHype']) {
        turnHype =
            '<span class="margin-left-12 grey help-text" title="Shocking turn Hype Boost">Turn Hype' +
            '<span class="faded-red-extra-light">' +
            '<i class="fa fa-bolt margin-right-5 margin-left-8"></i>' + feud['turnHype'] +
            '</span>' +
            '</span>'
    }

    let hotBoost = '';
    if (feud['boosts']['hotParticipantsBoost']) {
        hotBoost = '<span class="margin-left-12 grey help-text" title="Over Participants\' Boost">Over' +
            '<span class="faded-red-extra-light">' +
            '<i class="fa fa-bolt margin-right-5 margin-left-8"></i>' + feud['boosts']['hotParticipantsBoost'] +
            '</span>' +
            '</span>'
    }
    let staleBoost = '';
    if (feud['boosts']['staleParticipantsBoost']) {
        staleBoost = '<span class="margin-left-12 grey help-text" title="Stale Participants\' Penalty">Stale' +
            '<span class="faded-red-extra-light">' +
            '<i class="fa fa-bolt margin-right-5 margin-left-8"></i>' + feud['boosts']['staleParticipantsBoost'] +
            '</span>' +
            '</span>'
    }

    // Brands boost
    let brandsBoost = '';
    if (feud['boosts']['brandsBoost']) {
        brandsBoost = '<span class="margin-left-12 grey help-text" title="Different Brands Boost">Brands' +
            '<span class="faded-red-extra-light">' +
            '<i class="fa fa-bolt margin-right-5 margin-left-8"></i>' + feud['boosts']['brandsBoost'] +
            '</span>' +
            '</span>'
    }

    let factionsBoost = '';
    if (feud['boosts']['factionReputationBoost']) {
        factionsBoost = '<span class="margin-left-12 grey help-text" title="Faction REP Boost">Faction' +
            '<span class="faded-red-extra-light">' +
            '<i class="fa fa-bolt margin-right-5 margin-left-8"></i>' + feud['boosts']['factionReputationBoost'] +
            '</span>' +
            '</span>'
    }

    let boosts =
        '<span class="margin-left-12 grey help-text" title="Base Hype of the Feud Item">Base' +
        '<span class="faded-red-extra-light">' +
        '<i class="fa fa-bolt margin-right-5 margin-left-8"></i>' + feud['baseHype'] +
        '</span>' +
        '</span>' +
        '<span class="margin-left-12 grey help-text" title="Participants\' Rank Boost">Rank' +
        '<span class="faded-red-extra-light">' +
        '<i class="fa fa-bolt margin-right-5 margin-left-8"></i>' + feud['boosts']['rankBoost'] +
        '</span>' +
        '</span>' +
        '<span class="margin-left-12 grey help-text" title="Participants\' Alignment Boost">Aln.' +
        '<span class="faded-red-extra-light">' +
        '<i class="fa fa-bolt margin-right-5 margin-left-8"></i>' + feud['boosts']['alignmentBoost'] +
        '</span>' +
        '</span>' +
        hotBoost + staleBoost + brandsBoost +
        prev +
        turnHype +
        factionsBoost;
    html += boosts;

    return html;
}

function getFeudHypeIncreasedHtml(feud) {
    let participants = feud['participants'].join(' and ');
    return '<span class="faded-red-light">' + feud['newFeud'] + '</span> Feud increased the Hype of the ' +
        '<span class="faded-red-light">' + feud['name'] + '</span>' + ' Feud between ' + participants +
        ' by<span class="faded-red-light margin-right-8 margin-left-8"><i class="fa fa-bolt margin-right-5"></i>' +
        feud['hypeIncrease'] + '</span>';
}

function getGimmickEffectivenessLevelChangeHtml(gimmick) {
    let effectiveness = gimmick['effectiveness'];
    let effectivenessHtml = getGimmickEffectivenessText(effectiveness);
    let oldEffectiveness = effectiveness - gimmick['effectivenessChange'];
    let oldEffectivenessHtml = getGimmickEffectivenessText(oldEffectiveness);
    let gimmickName = '<span class="character-label">' + gimmick['name'] + '</span>';
    let overnessChangeHtml;

    // Gimmick Overness Effect Change
    if (gimmick['overnessEffectChange'] < 0) {
        gimmick['overnessEffectChange'] *= -1;
        overnessChangeHtml = '<span class="red">- ' + gimmick['overnessEffectChange'] + '</span>'
    }
    else {
        overnessChangeHtml = '<span class="green">+ ' + gimmick['overnessEffectChange'] + '</span>'
    }

    let verb;
    if (effectiveness > oldEffectiveness) {
        verb = 'progressed'
    }
    else {
        verb = 'declined'
    }
    let progress = '<span class="light-grey">' + oldEffectivenessHtml + ' to ' +
        effectivenessHtml + '</span>';
    return "{0}'s {1} Gimmick {2} from {3} changing Overness by {5}".format(gimmick['superstarName'],
        gimmickName, verb, progress, effectivenessHtml, overnessChangeHtml);
}

function showFactionReputationData(data) {

    // If faction reputation element present, update it
    let factionPrestigeElement = $('.faction-reputation[data-uid="' + data['uid'] + '"]');
    if (factionPrestigeElement.length > 0) {
        updateFactionReputationElement(data, factionPrestigeElement);
    }
    // Otherwise add new element
    else {
        let factionReputationHtml = getFactionReputationHtml(data);
        $("#prestige-results").find('.event-prestige-header').after(
            '<div class="faction-reputation margin-bottom-20" data-uid="' + data['uid'] + '">' +
            factionReputationHtml +
            '</div>'
        );
        factionPrestigeElement = $('.faction-reputation[data-uid="' + data['uid'] + '"]');
    }

    // Add animation for xp and progress change
    factionPrestigeElement.find('.reputation-xp').hide().fadeIn('slow');
    setTimeout(function () {
        factionPrestigeElement.find('.progress').addClass("expand-width");
    }, 0);
    setTimeout(function () {
        factionPrestigeElement.find('.progress').removeClass("expand-width");
    }, 1800);
}

function getFactionReputationHtml(data) {

    // Get max indication
    let maxHtml = '';
    if (data['reputation'] >= 10) {
        maxHtml = '<span class="margin-left-8 red">MAX</span>';
    }

    // Get xp change
    let xpChangeHtml = getFactionXpChangeHtml(data['xpChange']);

    // Get progress percentage
    let progressPercentage = data['progressPercentage'];
    if (progressPercentage <= 0) {
        progressPercentage = 1
    }

    // Add reputation data
    let reputationHtml =
        '<div class="display-block margin-bottom-8">' +
            '<div class="display-inline-block width-80 line-height-1p25em">' +
                '<span>' + data['factionName'] + '</span>' +
                '<span class="margin-left-8 light-grey">' + 'REP ' +
                    '<span class="reputation-value">' + data['reputation'] + '</span>' +
                '</span>' +
                maxHtml +
            '</div>' +
            '<div class="display-inline-block float-right">' +
                '<span class="margin-left-5 dark-grey reputation-xp">XP' +
                xpChangeHtml + '</span>' +
            '</div>' +
        '</div>' +
        '<div class="progress-under help-text faction-reputation-progress" title="' +
            data['xp'] + ' / ' + data['xpToNextReputation'] + ' XP">' +
            '<div class="progress" style="width:' + progressPercentage + '%">' + '</div>' +
        '</div>';

    // Get xp change details html (labels, values)
    let detailsHtml = getFactionXpChangeDetailsHtml(data);

    // XP change details div
    let xpChangeDetails =
        '<div class="faction-reputation-details margin-top-10">' +
        '<div class="column-left">' +
            detailsHtml[0] +
        '</div>' +
        '<div class="column-right">' +
            detailsHtml[1] +
        '</div>' +
        '<div class="clear"></div>' +
        '</div>';

    // Add button to show xp change details
    reputationHtml += '<div class="margin-top-15">' +
        '<button class="button retro-button condensed grey-button-background show-faction-reputation-details">Details</button>' +
        '</div>';
    reputationHtml += xpChangeDetails;

    return reputationHtml;
}

function updateFactionReputationElement(data, element) {

    // Add xp change details
    let detailsHtml = getFactionXpChangeDetailsHtml(data);
    let xpChangeDetails =
        '<div class="column-left margin-top-5">' +
            detailsHtml[0] +
        '</div>' +
        '<div class="column-right margin-top-5">' +
            detailsHtml[1] +
        '</div>' +
        '<div class="clear"></div>';
    element.find('.faction-reputation-details').append(xpChangeDetails);

    // Get progress percentage
    let progressPercentage = data['progressPercentage'];
    if (progressPercentage <= 0) {
        progressPercentage = 1
    }

    // Update reputation and progress
    element.find('.reputation-value').html(data['reputation']);
    element.find('.faction-reputation-progress').attr('title', data['xp'] + ' / ' + data['xpToNextReputation'] + ' XP');
    element.find('.progress').attr('style', 'width:' + progressPercentage + '%');

    // Update xp change
    let xpChangeValue = parseInt(element.find('.reputation-xp-value').attr('data-value'));
    xpChangeValue += data['xpChange'];
    let xpChangeHtml = getFactionXpChangeHtml(xpChangeValue);
    element.find('.reputation-xp').html('XP' + xpChangeHtml);
}

function getFactionXpChangeHtml(xpChange) {
    let xpChangeHtml;
    if (xpChange >= 0) {
        xpChangeHtml = '<span class="reputation-xp-value green margin-left-8" data-value="' + xpChange + '">+ ' +
            xpChange + '</span>'
    }
    else if (xpChange < 0) {
        xpChangeHtml = '<span class="reputation-xp-value red margin-left-8" data-value="' + xpChange + '">- ' +
            (-1 * xpChange) + '</span>'
    }
    return xpChangeHtml;
}

function getFactionXpChangeDetailsHtml(data) {
    let labelsHtml = '';
    let valuesHtml = '';
    let orderedKeys = ['addedMembers', 'removedMembers', 'championshipWon', 'championshipLost',
        'feudWon', 'feudLost', 'hot', 'stale', 'becameFotc', 'lostFotc'];

    // Show change for each item
    orderedKeys.forEach(function(key) {
        if (data['xpChangeDetails'][key]) {

            // Get leader boost if leader
            let leaderHtml = '';
            if (data['xpChangeDetails']['isLeader']) {
                leaderHtml = '<span class="light-grey display-block">1.25x Leader Multiplier</span>'
            }

            labelsHtml += '<div class="dark-grey help-text" title="' + getFactionReputationKeyHelp(key) + '">' +
                formatFactionReputationDetailsKey(key) + leaderHtml + '</div>';
            valuesHtml += '<div>' +
                formatFactionReputationDetailsValue(data['xpChangeDetails'][key]) + '</div>';
        }
    });
    return [labelsHtml, valuesHtml];
}

function getFactionReputationKeyHelp(key) {
    switch (key) {
        case 'addedMembers':
        case 'removedMembers':
            return 'Reputation changes with members added or removed, based on their popularity and overness.';
        case 'championshipWon':
        case 'championshipLost':
            return 'Reputation changes with championships won or lost by faction members.';
        case 'feudWon':
        case 'feudLost':
            return 'Reputation changes for Faction vs Faction feuds won or lost.';
        case 'hot':
        case 'stale':
            return 'Reputation changes if a faction member becomes hot or stale.';
        case 'becameFotc':
        case 'lostFotc':
            return 'Reputation changes if a faction member becomes a Face of the Company or loses their Face of the Company status.';
    }
}

function formatFactionReputationDetailsValue(value) {
    if (value >= 0) {
        value = '<span class="green"><span class="value-plus">+</span>' + value + '</span>'
    }
    else if (value < 0) {
        value = '<span class="red"><span class="value-minus">-</span>' + value * -1 + '</span>'
    }
    return value;
}

function formatFactionReputationDetailsKey(key) {
    switch (key) {
        case 'addedMembers':
            return 'Added Members';
        case 'removedMembers':
            return 'Removed Members';
        case 'championshipWon':
            return 'Won Championship';
        case 'championshipLost':
            return 'Lost Championship';
        case 'feudWon':
            return 'Won Feud';
        case 'feudLost':
            return 'Lost Feud';
        case 'hot':
            return 'Hot Member';
        case 'stale':
            return 'Stale Member';
        case 'becameFotc':
            return 'Became FotC';
        case 'lostFotc':
            return 'Lost FotC';
    }
}

function getChampionshipPrestigeHtml(data) {

    let progress = 100;
    let maxHtml = '';
    if (!data['maxPrestige']) {
        progress = data['progressPercentage'];
    }
    else {
        maxHtml = '<span class="margin-left-8 red">MAX</span>';
    }

    if (progress > 100) {
        progress = 100
    }
    else if (progress <= 0) {
        progress = 1
    }

    let xpChangeHtml;
    let xpChange = data['xpChange'];
    if (data['xpChange'] >= 0) {
        xpChangeHtml = '<span class="prestige-xp-value green margin-left-8">+ ' + xpChange + '</span>'
    }
    else if (data['xpChange'] < 0) {
        xpChangeHtml = '<span class="prestige-xp-value red margin-left-8">- ' +
            (-1 * xpChange) + '</span>'
    }

    let prestigeIcon = getChampionshipPrestigeIconHtml(data['prestige']);

    let prestigeText =
        '<div class="display-block margin-bottom-8">' +
        '<div class="display-inline-block width-80 line-height-1p25em">' +
        '<span>' + data['championshipName'] + '</span>' +
        '<span class="margin-left-5">' + prestigeIcon + '</span>' +
        maxHtml +
        '</div>' +
        '<div class="display-inline-block float-right">' +
        '<span class="margin-left-5 dark-grey prestige-xp">XP' +
        xpChangeHtml + '</span>' +
        '</div>' +
        '</div>' +
        '<div class="progress-under help-text championship-prestige-progress" title="' + data['xp'] + ' / ' +
        data['nextPrestigeXp'] + ' XP">' +
        '<div class="progress" style="width:' + progress + '%">' + '</div>' +
        '</div>';

    // Get prestige change details
    let labelsHtml = '';
    let valuesHtml = '';
    let orderedKeys = ['rating_change', 'segment_change', 'challenger_change', 'champion_change',
        'reign_change', 'feuds_change', 'main_event_change'];

    // Show change for each item
    orderedKeys.forEach(function(key) {
        if (data['xpDetails'][key]) {
            labelsHtml += '<div class="margin-bottom-3 grey help-text" title="' + getChampionshipPrestigeKeyHelp(key) + '">' +
                formatChampionshipPrestigeDetailsKey(key) + '</div>';
            valuesHtml += '<div class="margin-bottom-3">' +
                formatChampionshipPrestigeDetailsValue(data['xpDetails'][key]) + '</div>';
        }
    });

    // Show total change
    labelsHtml += '<div class="dark-grey margin-top-12">Total</div>';
    valuesHtml += '<div class="margin-top-12">' +
        formatChampionshipPrestigeDetailsValue(data['xpDetails']['totalXpChange']) + '</div>';

    // Prestige change details div
    let prestigeChangeDetails =
        '<div class="championship-prestige-details margin-top-12 display-none">' +
        '<div class="column-left">' +
            labelsHtml +
        '</div>' +
        '<div class="column-right">' +
            valuesHtml +
        '</div>' +
        '<div class="clear"></div>' +
        '</div>';

    prestigeText += '<div class="margin-top-15">' +
        '<button class="button retro-button condensed grey-button-background show-championship-prestige-details">Details</button>' +
        '</div>';
    prestigeText += prestigeChangeDetails;

    // Prestige increase/decrease text
    if (data['prestigeIncrease']) {
        prestigeText += '<span class="gold display-block margin-top-12">Prestige Increased</span>';
    }
    else if (data['prestigeDecrease']) {
        prestigeText += '<span class="puke-green display-block margin-top-12">Prestige Decreased</span>';
    }

    return prestigeText;
}

function formatChampionshipPrestigeDetailsValue(value) {
    if (value > 0) {
        value = '<span class="green"><span class="value-plus">+</span>' + value + '</span>'
    }
    else if (value < 0) {
        value = '<span class="red"><span class="value-minus">-</span>' + value * -1 + '</span>'
    }
    return value;
}

function formatChampionshipPrestigeDetailsKey(key) {
    switch (key) {
        case 'rating_change':
            return 'Rating';
        case 'segment_change':
            return 'Segment';
        case 'challenger_change':
            return 'Challenger';
        case 'champion_change':
            return 'Champion';
        case 'reign_change':
            return 'Reign';
        case 'feuds_change':
            return 'Feuds';
        case 'main_event_change':
            return 'Main Event';
    }
}

function getChampionshipPrestigeKeyHelp(key) {
    switch (key) {
        case 'rating_change':
            return 'Prestige increases with high Match Ratings and decreases with low Match Ratings.';
        case 'segment_change':
            return 'Prestige increases/decreases with certain Segments.';
        case 'challenger_change':
            return 'Prestige increases for credible challengers and decreases for non-credible challengers.';
        case 'champion_change':
            return 'Prestige increases for credible champions and decreases for non-credible champions. Championship ' +
                'wins result in a higher change.';
        case 'reign_change':
            return 'Prestige increases for every 3 months of a Championship Reign based on the number of defenses. ' +
                'Prestige decreases for each previous Championship Reign shorter than 3 months.';
        case 'feuds_change':
            return 'Prestige increases for Hot Feuds and decreases for Stale Feuds.';
        case 'main_event_change':
            return 'Prestige increases if a non-top Championship is put in the Main Event (Match or Segment). ' +
                'Prestige decreases if the ' +
                'top Championship is not put in the Main Event (only for Matches).';
    }
}

function getRosterInfo(roster, competitor, showGraphicsPercentage = true, showFuture = true) {
    let topSuperstarsDiv = getItemListDiv(roster['topSuperstars']);
    let futureSuperstarsDiv = (roster['futureSuperstars'] !== undefined && showFuture) ?
        getItemColumnDiv('Future', getItemListDiv(roster['futureSuperstars'])) : '';
    let retiredSuperstarsDiv = (roster['retiredSuperstars'] !== undefined) ?
        getItemColumnDiv('Retired', getItemListDiv(roster['retiredSuperstars'])) : '';
    let rosterType = roster['name'] ? toTitleCase(roster['name'].replace('-', ' ')) :
        `${toTitleCase(roster['type'])} Roster`;
    let topTagTeamDiv = (roster['topTagTeam']) ?
        getItemColumnDiv('Top Tag Team', roster['topTagTeam']) : '';
    let topTrioDiv = (roster['topTrio']) ?
        getItemColumnDiv('Top Trio', roster['topTrio']) : '';

    let graphicsPercentage = '';
    if (showGraphicsPercentage) {
        graphicsPercentage = getGraphicsPercentageDiv(roster['numberOfSuperstarsWithGraphics'],
            roster['numberOfSuperstars']);
    }
    let numberOfGimmicks = (roster['numberOfSuperstarsWithGimmicks'] !== undefined && !competitor) ?
        getItemColumnDiv('Gimmicks', roster['numberOfSuperstarsWithGimmicks']) : '';
    let numberOfOver = (roster['numberOfOverSuperstars'] !== undefined && !competitor) ?
        getItemColumnDiv('Over', roster['numberOfOverSuperstars']) : '';
    let numberOfStale = (roster['numberOfStaleSuperstars'] !== undefined && !competitor) ?
        getItemColumnDiv('Stale', roster['numberOfOverSuperstars']) : '';
    let numberOfFaces = (roster['numberOfFaceSuperstars'] !== undefined && !competitor) ?
        getItemColumnDiv('Faces', roster['numberOfFaceSuperstars']) : '';
    let numberOfHeel = (roster['numberOfHeelSuperstars'] !== undefined && !competitor) ?
        getItemColumnDiv('Heels', roster['numberOfHeelSuperstars']) : '';
    let numberOfTraits = (roster['numberOfSuperstarsWithTraits'] !== undefined && !competitor) ?
        getItemColumnDiv('Traits', roster['numberOfSuperstarsWithTraits']) : '';

    let classes = (competitor) ? 'blue margin-bottom-5' : 'blue font-1p25em margin-bottom-12';

    return '<div class="margin-bottom-25">' +
        '<div class="' + classes + '">' + rosterType + '</div>' +
        getItemColumnDiv('Superstars', roster['numberOfSuperstars']) +
        getItemColumnDiv('Tag Teams', roster['numberOfTagTeams']) +
        getItemColumnDiv('Trios', roster['numberOfTrios']) +
        getItemColumnDiv('Factions', roster['numberOfFactions']) +
        getItemColumnDiv('Managers', roster['numberOfManagers']) +
        getItemColumnDiv('Top Superstars', topSuperstarsDiv) +
        topTagTeamDiv +
        topTrioDiv +
        retiredSuperstarsDiv +
        futureSuperstarsDiv +
        graphicsPercentage +
        numberOfGimmicks +
        numberOfOver +
        numberOfStale +
        numberOfFaces +
        numberOfHeel +
        numberOfTraits +
        '</div>';
}

function getChampionshipsInfo(championships, competitor, showGraphicsPercentage) {
    if (typeof(showGraphicsPercentage) === 'undefined') showGraphicsPercentage = true;
    let championshipsPercentage = '';
    if (showGraphicsPercentage) {
        championshipsPercentage = getGraphicsPercentageDiv(championships['numberOfChampionshipsWithGraphics'],
            championships['numberOfChampionships']);
    }
    let topChampionshipsDiv = '';
    championships['topChampionships'].forEach(function (championship) {
        let champion = (championship['championName']) ? championship['championName'] : 'Vacant';
        topChampionshipsDiv += '<div class="display-block margin-bottom-3"><span class="gold">{0}</span> <span class="grey display-block">{1}</span></div>'.format(championship['name'],
            champion);
    });
    let classes = (competitor) ? 'blue margin-bottom-5' : 'blue font-1p25em margin-bottom-12';
    return '<div class="margin-bottom-25">' +
        '<div class="' + classes + '">Championships</div>' +
        getItemColumnDiv('Top', topChampionshipsDiv) +
        championshipsPercentage +
        '</div>';
}

function getCompanyInfo(company, competitor) {
    // Based on Python data format
    let classes = (competitor) ? 'blue margin-bottom-5' : 'blue font-1p25em margin-bottom-12';

    let prestigeIcon = '';
    switch (company['topEvent']['prestige']) {
        case 'C':
            prestigeIcon = '<i class="fa fa-star-o font-bold bronze"></i>';
            break;
        case 'B':
            prestigeIcon = '<i class="fa fa-star-o font-bold silver"></i>';
            break;
        case 'A':
            prestigeIcon = '<i class="fa fa-star-o font-bold gold-light"></i>';
            break;
    }
    let topEvent = '{0} {1}'.format(company['topEvent']['name'], prestigeIcon);

    let owner = (company['ownerName']) ? company['ownerName'] : 'None';

    return '<div class="margin-bottom-25">' +
        '<div class="' + classes + '">Company</div>' +
        getItemColumnDiv('Name', company['companyName']) +
        getItemColumnDiv('REP', company['reputation']) +
        getItemColumnDiv('Owner', owner) +
        getItemColumnDiv('Top Event', topEvent) +
        getItemColumnDiv('Style', toTitleCase(company['style'])) +
        '</div>';
}

function getBrandsInfo(brands, competitor) {
    // Based on Python data format

    let brandsHtml = '';
    brands.forEach(function (brand) {
        // Get brand exclusive objects info
        let brandSuperstarsWord = (brand['superstars'].length === 1) ? 'Superstar' : 'Superstars';
        let brandSuperstarsHtml = '{0} {1}'.format(brand['superstars'].length, brandSuperstarsWord);
        let brandChampionshipsWord = (brand['championships'].length === 1) ? 'Championship' : 'Championships';
        let brandChampionshipsHtml = '{0} {1}'.format(brand['championships'].length, brandChampionshipsWord);
        let brandEventsWord = (brand['events'].length === 1) ? 'Event' : 'Events';
        let brandEventsHtml = '{0} {1}'.format(brand['events'].length, brandEventsWord);
        let brandNumberOfObjects = getItemListDiv([brandSuperstarsHtml, brandChampionshipsHtml, brandEventsHtml]);

        // Get brand name and color
        let brandNameStyleHtml = '';
        if (brand['color'] && !globalUser.settings.colorblindMode) {
            brandNameStyleHtml = ' style="color: ' + brand['color'] + '"';
        }
        let brandNameHtml = '<div' + brandNameStyleHtml + '>' + brand['name'] + '</div>';

        brandsHtml += getItemColumnDiv(brandNameHtml, brandNumberOfObjects);
    });
    if (brands.length <= 0) {
        brandsHtml += '<div class="medium-grey">None</div>'
    }

    let classes = (competitor) ? 'blue margin-bottom-5' : 'blue font-1p25em margin-bottom-12';
    return '<div class="margin-bottom-25">' +
        '<div class="' + classes + '">Brands</div>' +
        brandsHtml +
        '</div>';
}

function getItemColumnDiv(itemName, itemValue) {
    return '<div class="margin-bottom-8">' +
        '<div class="scenario-information-column-left medium-grey">{0}</div>'.format(itemName) +
        '<div class="scenario-information-column-right">{0}</div>'.format(itemValue) +
        '<div class="clear"></div>' +
        '</div>';
}

function getItemListDiv(list) {
    let div = '';
    list.forEach(function (item) {
        div += '<div class="display-block">{0}</div>'.format(item);
    })
    if (list.length < 1) {
        div = 'None'
    }
    return div;
}

function getGraphicsPercentageDiv(graphics, total) {
    let percentage = Math.round((graphics * 1.0 / total) * 100);
    let percentageClass;
    if (percentage < 25) {
        percentageClass = 'red'
    }
    else if (percentage < 75) {
        percentageClass = 'dark-yellow'
    }
    else {
        percentageClass = 'green'
    }
    let graphicsDiv = '<span class="' + percentageClass + '">' + percentage + ' %</span>';
    return getItemColumnDiv('Graphics', graphicsDiv)
}

function toCamel(item) {
    if (Array.isArray(item)) {
        return item.map(el => toCamel(el));
    } else if (typeof item === 'function' || item !== Object(item)) {
        return item;
    }
    return Object.fromEntries(
        Object.entries(item).map(([key, value]) => [
            key.replace(/([-_][a-z])/gi, c => c.toUpperCase().replace(/[-_]/g, '')),
            toCamel(value),
        ]),
    );
}

function showFormattedDisplayName(user) {
    let formattedName = user.displayName;
    if (user.displayName.length > 7) {
        $('.user-display-name').addClass('help-text').attr('title', user.displayName);
        formattedName = user.displayName.slice(0, 7) + '...';
    }
    $('.user-display-name').text(formattedName);
}

let previewSegmentSinglesParticipants = [
    {'name': 'Jimmy', 'type': 'he'},
    {'name': 'Adam', 'type': 'he'},
    {'name': 'Ben', 'type': 'he'},
    {'name': 'Molly', 'type': 'she'},
    {'name': 'Shirley', 'type': 'she'}
];
let previewSegmentTagParticipants = [
    {'name': 'Dangerous Twins', 'type': 'tag'},
    {'name': 'The Ugly Duo', 'type': 'tag'},
    {'name': 'Gorgeous Bunch', 'type': 'tag'},
    {'name': 'Butcher Boys', 'type': 'tag'},
    {'name': 'Dirt & Fortune', 'type': 'tag'},
    {'name': 'Lion Tamers', 'type': 'tag'},
    {'name': 'Pain & Pleasure', 'type': 'tag'},
    {'name': 'Funk and Wolfman', 'type': 'tag'}
];

export {getFansHtml, getPointsHtml, hideContent, getChampionshipsDisplayName, formatCompanyName, escapeHTML, monthNames,
    hideMainMenuContent, getOvernessLevelText, getRosterMemberMoraleClass, getRosterMemberMoraleText,
    getSuperstarTraitHelpHtml, getChampionshipPrestigeIconHtml, getStarRatingHtml, getChampionshipDisplayName,
    getRosterMemberAlignmentHtml, getRosterMemberFatigueClass, getSuperstarInjuredText, parseObjectiveName,
    getViewershipText, formatCompanyNameBackend, getShortenedName, setRating, applySentenceCase, runFuseElementsSearch,
    replaceAll, getChampionshipGimmickRestrictionText, getChampionshipPrestigeProgressHtml, getCompanyHeaderHtml,
    getGimmickDescription, populateBrandNameSelect, makeGameRequest, getTimesWord, predicateBy, objectEquals,
    getFeudPotentialHtml, hideEventCardContent, getChampionshipGimmickRestrictionInfoHtml, getGimmickMatchUnlockedBy,
    updateGamePointsAndFans, getGimmickDebutHtml, addTournamentParticipantsEditing, getTournamentGroupsHtml,
    getFeudStartedHtml, getFeudHypeIncreasedHtml, getGimmickEffectivenessLevelChangeHtml, showFactionReputationData,
    getChampionshipPrestigeHtml, getGimmickEffectivenessHtml, getTournamentGroupName, getRosterInfo, getItemColumnDiv,
    getChampionshipsInfo, runAnnualTournamentSelectionsSearch, getItemListDiv, getCompanyInfo, getBrandsInfo, toCamel,
    getTraitHelpHtml, getTalentRequestTypesHelpHtml, previewSegmentSinglesParticipants, previewSegmentTagParticipants,
    makeGetRequest, requestTimeout, showFormattedDisplayName}